module.exports = __webpack_public_path__ + "media/cow_bell.5176e061.ogg";